import { Component } from '@angular/core';

@Component({
  standalone: false,
    selector: 'faro-loading-indicator-dots',
    templateUrl: './loading-indicator-dots.component.html',
    styleUrls: ['./loading-indicator-dots.component.scss'],
})
export class LoadingIndicatorDotsComponent {}
